// ==========================================
// src/lib/AdminAuthContext.jsx — V8 DEFINITIVO
// ✅ NÃO chama signOut() quando usuário não é admin
// ✅ NÃO interfere em login de empresa/motorista
// ==========================================
import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { supabase } from './supabase';
import { toast } from 'sonner';

const AdminAuthContext = createContext(undefined);

const getAdminCredentials = () => ({
  username: 'jltradeagrobusiness',
  password: '020507Bf1@JoseR',
  email: 'adminborafrete@gmail.com',
  supabasePassword: '020507Bf1@JoseR'
});

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const checkSession = useCallback(async () => {
    setIsLoading(true);
    try {
      // OPÇÃO 1: Verifica login LOCAL primeiro
      const savedSession = localStorage.getItem('borafrete_admin_session');
      const savedAuth = localStorage.getItem('borafrete_admin_auth');
      
      if (savedSession && savedAuth === 'true') {
        const sessionData = JSON.parse(savedSession);
        if (sessionData.expiresAt && new Date(sessionData.expiresAt) > new Date()) {
          console.log('✅ Sessão admin LOCAL restaurada:', sessionData.username);
          setAdmin(sessionData);
          setIsLoading(false);
          return;
        } else {
          localStorage.removeItem('borafrete_admin_session');
          localStorage.removeItem('borafrete_admin_auth');
        }
      }

      // OPÇÃO 2: Se não tem local, tenta Supabase
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      
      if (sessionError || !session) {
        console.log('⚠️ Sem sessão Supabase ativa');
        setAdmin(null);
        setIsLoading(false);
        return;
      }

      // Verifica se é admin no profiles
      const { data: profile, error: profileError } = await supabase
        .from('profiles')
        .select('tipo, role, nome')
        .eq('id', session.user.id)
        .single();

      // ✅ CORREÇÃO: Se não é admin, SÓ ignora. NÃO desloga!
      if (profileError || !profile || profile.tipo !== 'admin') {
        console.log('⚠️ Usuário não é admin, ignorando...');
        setAdmin(null);
        setIsLoading(false);
        return;
      }

      // É admin — cria sessão local
      const credentials = getAdminCredentials();
      const user = {
        id: 'admin_001',
        username: credentials.username,
        role: 'super_admin',
        isAuthenticated: true,
        token: btoa(`${credentials.username}:${Date.now()}`),
        loginAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString()
      };
      
      localStorage.setItem('borafrete_admin_session', JSON.stringify(user));
      localStorage.setItem('borafrete_admin_auth', 'true');
      
      setAdmin(user);
      console.log('✅ Sessão admin SUPABASE restaurada:', session.user.email);

    } catch (err) {
      console.error('❌ Erro ao verificar sessão:', err);
      setAdmin(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    checkSession();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('📡 AdminAuth event:', event);
      
      if (event === 'SIGNED_IN' || event === 'INITIAL_SESSION') {
        setTimeout(() => checkSession(), 100);
      }
      
      // ✅ CORREÇÃO: SIGNED_OUT só limpa admin se realmente era admin
      if (event === 'SIGNED_OUT') {
        const savedAuth = localStorage.getItem('borafrete_admin_auth');
        if (savedAuth === 'true') {
          console.log('👋 Admin SIGNED_OUT real');
          setAdmin(null);
          localStorage.removeItem('borafrete_admin_session');
          localStorage.removeItem('borafrete_admin_auth');
        } else {
          console.log('🛡️ SIGNED_OUT ignorado (não era admin)');
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [checkSession]);

  const login = useCallback(async (username, password) => {
    setIsLoading(true);
    setError(null);
    
    await new Promise(resolve => setTimeout(resolve, 800));
    
    const credentials = getAdminCredentials();
    
    if (username !== credentials.username || password !== credentials.password) {
      setError('Usuário ou senha incorretos');
      setIsLoading(false);
      return { success: false, error: 'Usuário ou senha incorretos' };
    }

    try {
      console.log('🔑 Fazendo login no Supabase Auth...');
      
      const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
        email: credentials.email,
        password: credentials.supabasePassword
      });

      if (authError) {
        console.error('❌ Erro Supabase Auth:', authError);
        setError('Erro de autenticação no banco: ' + authError.message);
        setIsLoading(false);
        return { success: false, error: 'Supabase Auth falhou: ' + authError.message };
      }

      console.log('✅ Logado no Supabase Auth:', authData.user?.id);

      const { data: profileData, error: profileError } = await supabase
        .from('profiles')
        .select('tipo, role')
        .eq('id', authData.user.id)
        .single();

      if (profileError || !profileData || profileData.tipo !== 'admin') {
        console.error('❌ Usuário não é admin:', profileError, profileData);
        // ✅ CORREÇÃO: NÃO chama signOut() aqui!
        setError('Usuário autenticado mas não tem permissão de admin no banco.');
        setIsLoading(false);
        return { success: false, error: 'Sem permissão de admin' };
      }

      console.log('✅ Perfil admin confirmado');

      const token = btoa(`${credentials.username}:${Date.now()}`);
      const user = {
        id: 'admin_001',
        username: credentials.username,
        role: 'super_admin',
        isAuthenticated: true,
        token: token,
        loginAt: new Date().toISOString(),
        expiresAt: new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString()
      };
      
      localStorage.setItem('borafrete_admin_session', JSON.stringify(user));
      localStorage.setItem('borafrete_admin_auth', 'true');
      
      setAdmin(user);
      setIsLoading(false);
      toast.success('✅ Login admin realizado com sucesso!');
      return { success: true };

    } catch (supabaseErr) {
      console.error('❌ Falha crítica no Supabase:', supabaseErr);
      setError('Falha na autenticação do banco. Tente novamente.');
      setIsLoading(false);
      return { success: false, error: supabaseErr.message };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await supabase.auth.signOut();
      console.log('✅ Logout do Supabase realizado');
    } catch (err) {
      console.warn('⚠️ Erro no logout Supabase:', err);
    }

    setAdmin(null);
    setError(null);
    localStorage.removeItem('borafrete_admin_session');
    localStorage.removeItem('borafrete_admin_auth');
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{
      admin,
      isAuthenticated: !!admin,
      isLoading,
      error,
      login,
      logout,
      clearError
    }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) throw new Error('useAdminAuth deve ser usado dentro de AdminAuthProvider');
  return context;
};